import { PAYPAY_POINTS_PCT } from './PointsSection.constants'

export function calculatePaypayPoints(priceAmount: string): number {
  return Math.trunc((parseInt(priceAmount, 10) / 100) * PAYPAY_POINTS_PCT)
}
